//
// DataDefinition.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "./DataDefinitionType";
import "../dataSource/DataSource";
import "./DataItemBase";
import "./relational/RelationalQuery";
import "./multiDimensional/MultidimensionalQuery";
import "./pluggable/PluggableQuery";
import "./procedural/ProceduralQuery";
import "./ResultDefinition";
import "./ExecutionModelPreference";

var DataDefinition = createModule("BIRD::DataDefinition", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        pluggableQuery: 1,
        name: 7,
        businessItems: [1],
        executionModelPreference: 4,
        multidimensionalQuery: 1,
        proceduralQuery: 1,
        type: 4,
        dataSource: 1,
        relationalQuery: 1,
        resultDefinitions: [1],
    },
    {
        parentDefinition: 1,
    },
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default DataDefinition;
